import { Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProductHistory } from "../../data/entities";
import { productHistoryReduxActions } from "../state/state";

export const ProductHistoryDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(productHistoryReduxActions.getDetail(id));
  }, [dispatch, id]);
  const productHistoryDetailBranch = useSelector<IAppReduxState, IAsyncData<IProductHistory>>(
    (state) => state.productHistory.details,
  );

  const deleteProductHistory = async (id: string): Promise<void> => {
    await dispatch(productHistoryReduxActions.delete(id));
    history.push(ROUTES.productHistory);
  };
  const deleteBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.productHistory.delete);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <DetailTable
          branch={productHistoryDetailBranch}
          route={ROUTES.productHistory}
          onDelete={deleteProductHistory}
          deleteBranch={deleteBranch}
        >
          <Table size="medium" className="detail-table">
            <TableBody>
              <TableRow>
                <TableCell>dirtyWeightAfter</TableCell>
                <TableCell>{productHistoryDetailBranch.data?.dirtyWeightAfter}</TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell>defaultWastePercent</TableCell>
                <TableCell>{productHistoryDetailBranch.data?.defaultWastePercent}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>wastePercent</TableCell>
                <TableCell>{productHistoryDetailBranch.data?.wastePercent}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>dirtyWeight</TableCell>
                <TableCell>{productHistoryDetailBranch.data?.dirtyWeight}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>totalPrice</TableCell>
                <TableCell>{productHistoryDetailBranch.data?.totalPrice}</TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
        </DetailTable>
      </Grid>
    </Grid>
  );
};
